import * as React from 'react';
import * as main from "../../main.module.scss";
import * as themes from "./style.module.scss";
export const Themes = () => {
  return (
    <section className={themes.themes}>
      <div className="container">
        <div className={`${themes.container} ${main.bg}`}>
          <h2 className={main.title}>Курс состоит из 7 тематических блоков</h2>
          <p className={themes.desc}>Каждый блок включает в себя несколько уроков по одной теме в сфере IT.</p>
          <ul>
            <li>
              <p><strong>Development</strong> (Разработка)</p>
            </li>
            <li>
              <p><strong>Coding</strong> (Написание программного кода)</p>
            </li>
            <li>
              <p><strong>Data</strong> (Термины данных)</p>
            </li>
            <li>
              <p><strong>Hardware</strong> (Аппаратное обеспечение)</p>
            </li>
            <li>
              <p><strong>Mobile Technology</strong> (Термины в области мобильных технологий)</p>
            </li>
            <li>
              <p><strong>System</strong> (Системные термины)</p>
            </li>
            <li>
              <p><strong>Other terms</strong> (Другие термины)</p>
            </li>
          </ul>
          <p className={themes.duration}>
            Длительность курса — примерно <strong>10 часов</strong><br/>
            (зависит от уровня студента и его индивидуальных особенностей)
          </p>
        </div>
      </div>
    </section>
  );
};
